<template>
	<div>
		<v-menu
			:value="step == current && active"
			:close-on-content-click="false"
			:close-on-click="false"
			:nudge-bottom="bottom && !top && !left ? 50 : 0"
			:nudge-top="top ? 15 : 0"
            :nudge-left="left ? 150 : 0"
			nudge-width="-100"
			min-width="100"
			max-width="600"
			offset-y
			:bottom="bottom && !top && !left"
			:top="top"
            :left="left"
			z-index="1001"
			:activator="activator"
			rounded="500"
		>
			<template v-slot:activator="{ on, attrs }">
				<div v-bind:click="{ undefined: step == current && active }" :class="{ tutorialElement: step == current && active }">
					<slot v-bind:content="{ on, attrs }"></slot>
				</div>
			</template>
			<!-- <template v-slot:activator="{ on, attrs }">
				<v-btn color="indigo" dark v-bind="attrs" v-on="on">
					Menu as Popover
				</v-btn>
			</template> -->

			<v-card elevation="0">
				<v-card-actions>
					<v-spacer />
					<v-btn icon color="grey lighten-1" @click="abort"
						><v-icon large>fas fa-times</v-icon></v-btn
					>
				</v-card-actions>
				<v-card-title class="pt-0 px-9">
					{{ title }}
				</v-card-title>
				<v-card-text class="px-9">
					<p>
						{{ body }}
					</p>
				</v-card-text>
				<v-divider width="90%" class="mx-auto" />
				<v-card-text
					style="font-size: 1.2rem !important"
					class="text-center pb-0"
				>
					<b>{{ current + 1 }} / {{ total }}</b>
				</v-card-text>

				<v-card-actions class="justify-center pb-5 px-5">
					<v-btn outlined v-if="current > 0" color="primary" @click="prevStep">
						Back
					</v-btn>
					<v-spacer />
					<v-btn color="primary" @click="nextStep">
						{{current == total-1 ? "Finish" : "Next"}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
export default {
	data() {
		return {
			menu: true
		}
	},
	props: {
		title: String,
		body: String,
		activator: null,
		step: [Number, String],
		current: Number,
		total: Number,
		bottom: {
			type: Boolean,
			default: true
		},
		top: {
			type: Boolean,
			default: false
		},
		left: {
			type: Boolean,
			default: false
		},
		active: {
			type: Boolean,
			default: true
		}
	},
	computed: {},
	methods: {
		nextStep() {
			this.$emit("next-step")
		},
		prevStep() {
			this.$emit("prev-step")
		},
		abort() {
			this.$emit("abort")
		}
	}
}
</script>

<style>
.tutorialElement {
	position: relative;
	z-index: 999;
}
</style>
